export const VALID_SFR_FORMS = ['FNM1004', 'FNM2055'];
export const VALID_MANUFACTURED_FORMS = ['FNM1004C'];
export const VALID_MULTIFAMILY_FORMS = ['FNM1025'];
export const VALID_CONDO_FORMS = ['FNM1073', 'FNM1075'];

export const VALID_FORMS = [
  ...VALID_SFR_FORMS,
  ...VALID_MULTIFAMILY_FORMS,
  ...VALID_MANUFACTURED_FORMS,
];

/**
 * Matches MLS#ListingID with allowance for extra spaces (e.g. NWMLS # 12345)
 *
 * Group 1 = whole string
 *
 * Group 2 = MLS
 *
 * Group 3 = ListingID
 */
export const MLS_ID_REGEX = new RegExp(/((\w+)\s*#\s*([^.;, ]+))(?:[.;, ]|$)/);
